import React from 'react';
import { Navigate } from "react-router-dom";
import { useAppContext } from '../../context';

const PrivateRoute = ({ children, redirectTo }) => {

    const {
        state: {
            user
        }
    } = useAppContext();

    return user?.isSignedIn
        ? children
        : <Navigate to={redirectTo} replace />;
};

export default PrivateRoute;